export default "__VITE_ASSET__CB9tgb_H__"